import React from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from '@xingternal/merge-styles';

const withPresets = (presets, shouldKeepProp) => Component => {
  const WrappingComponent = ({ skin: userSkin = undefined, ...props }) => {
    const activePresets = Object.keys(presets)
      .filter(preset => props[preset])
      .map(preset => presets[preset])
      .concat([userSkin]);
    if (!shouldKeepProp) {
      Object.keys(presets).forEach(key => {
        delete props[key];
      });
    }
    const skin = mergeStyles(...activePresets);
    Component.displayName = `withPresets(${Component.name ||
      Component.displayName})`;

    return <Component {...{ ...props, skin }} />;
  };
  WrappingComponent.propTypes = {
    skin: PropTypes.object,
  };
  WrappingComponent.displayName = `withPresets(${Component.name ||
    Component.displayName})`;
  return WrappingComponent;
};

export default withPresets;
